<!-- <h4 class="title">Loan Details</h4> -->
<!-- <br> -->
<div class="card-box" style="margin: 2px;">
    <div class="row" style="margin-right: 0px;margin-left: 0px;">
        <!-- <div class="col-md-4">
        <div class="search-hero">
            <input class="form-control" type="text" name="search2" style="font-family: FontAwesome;"
                [(ngModel)]="searchQR" autocomplete="off" placeholder="&#xf002; Search...">
        </div>
    </div> -->

        <!-- <div class="col-md-5">
            <h5 class="form-lable">Loan Number: <span>1234568908765432</span></h5>
        </div>
        <div class="col-md-5">
            <h5 class="form-lable">Customer Name: <span>Mohammed Imthiyas</span></h5>
        </div> -->
        <!-- <div class="col-md-2 text-right">
        <button type="button" class="btn btn-primary mr-0" (click)="show2()">Add</button>
    </div> -->
        <!-- <div class="col-md-12">
        <div class="doc-table">
            <table class="det-t">
                    <tr style="text-align: left;">
                        <th>Financier:</th>
                        <td><input type=""></td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>LOB:</th>
                        <td><input type=""></td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>Loan Type:</th>
                        <td><input type=""></td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>Loan Currency:</th>
                        <td><input type=""></td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>Scheme:</th>
                        <td><input type=""></td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>Loan Financed:</th>
                        <td><input type=""></td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>Interest Type:</th>
                        <td><input type=""></td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>Interest Rate(%):</th>
                        <td><input type=""></td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>Tenure:</th>
                        <td><input type=""></td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>Asset Cost:</th>
                        <td><input type=""></td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>Sourcing Dealer:</th>
                        <td><input type=""></td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>Security Deposite:</th>
                        <td><input type=""></td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>No. of installments:</th>
                        <td><input type=""></td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>Frequency:</th>
                        <td><input type=""></td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>Installment Mode:</th>
                        <td><input type=""></td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>EMI:</th>
                        <td><input type=""></td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>Billed Installment:</th>
                        <td><input type=""></td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>Due Date:</th>
                        <td><input type=""></td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>Collection Cycle:</th>
                        <td><input type=""></td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>Cycle Date:</th>
                        <td><input type=""></td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>Loan To Value:</th>
                        <td><input type=""></td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>Note Date:</th>
                        <td><input type=""></td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>EMI Start Date:</th>
                        <td><input type=""></td>
                    </tr>
            </table>
        </div>
    </div> -->
        <div class="col-md-12">
            <h4 class="title-f">Loan Details</h4>
            <div class="row" style="padding: 0px 0px 36px 10px;">
                <div class="col-md-3">
                    <h5 class="form-lable">Financier:</h5>
                    <input type="text" pInputText disabled=true placeholder="" value="NA">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">LOB:</h5>
                    <input type="text" pInputText disabled=true placeholder="" value="NA">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Loan Type:</h5>
                    <input type="text" pInputText disabled=true placeholder="" value="NA">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Loan Currency:</h5>
                    <input type="text" pInputText disabled=true placeholder="" value="NA">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Scheme:</h5>
                    <input type="text" pInputText disabled=true placeholder="" value="NA">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Loan Financed:</h5>
                    <input type="text" pInputText disabled=true placeholder="" value="NA">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Interest Type:</h5>
                    <input type="text" pInputText disabled=true placeholder="" value="NA">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Interest Rate(%):</h5>
                    <input type="text" pInputText disabled=true placeholder="" value="NA">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Tenure:</h5>
                    <input type="text" pInputText disabled=true placeholder="" value="NA">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Asset Cost:</h5>
                    <input type="text" pInputText disabled=true placeholder="" value="NA">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Sourcing Dealer:</h5>
                    <input type="text" pInputText disabled=true placeholder="" value="NA">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Sourcing Dealer:</h5>
                    <input type="text" pInputText disabled=true placeholder="" value="NA">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">No. of installments:</h5>
                    <input type="text" pInputText disabled=true placeholder="" value="NA">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Frequency:</h5>
                    <input type="text" pInputText disabled=true placeholder="">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Installment Mode:</h5>
                    <input type="text" pInputText disabled=true placeholder="">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">EMI:</h5>
                    <input type="text" pInputText disabled=true placeholder="">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Billed Installment:</h5>
                    <input type="text" pInputText disabled=true placeholder="">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Due Date:</h5>
                    <input type="text" pInputText disabled=true placeholder="">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Collection Cycle:</h5>
                    <input type="text" pInputText disabled=true placeholder="">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Cycle Date:</h5>
                    <input type="text" pInputText disabled=true placeholder="">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Loan To value: </h5>
                    <input type="text" pInputText disabled=true placeholder="">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Note Date:</h5>
                    <input type="text" pInputText disabled=true placeholder="">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">EMI Start Date:</h5>
                    <input type="text" pInputText disabled=true placeholder="">
                </div>

                <!-- <div class="col-md-12 mt-20">
                  <button type="button" class="btn btn-primary">Add</button>
             </div> -->

            </div>
            <hr>



        </div>
        <div class="col-md-12">
            <h4 class="title-f">Overdue Details</h4>
            <div class="row" style="padding: 0px 0px 36px 10px;">
                <div class="col-md-3">
                    <h5 class="form-lable">DPD:</h5>
                    <input type="text" pInputText disabled=true placeholder="" value="NA">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Bucket/Cycles:</h5>
                    <input type="text" pInputText disabled=true placeholder="" value="NA">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">No. of installments Overdue:</h5>
                    <input type="text" pInputText disabled=true placeholder="" value="NA">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Total Amount Overdue:</h5>
                    <input type="text" pInputText disabled=true placeholder="" value="NA">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Interest Overdue:</h5>
                    <input type="text" pInputText disabled=true placeholder="" value="NA">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Total Charges Overdue:</h5>
                    <input type="text" pInputText disabled=true placeholder="" value="NA">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Other Charges:</h5>
                    <input type="text" pInputText disabled=true placeholder="" value="NA">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Cheque Bounce Counter:</h5>
                    <input type="text" pInputText disabled=true placeholder="" value="NA">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Accrued Interest:</h5>
                    <input type="text" pInputText disabled=true placeholder="" value="NA">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Suspense Interest:</h5>
                    <input type="text" pInputText disabled=true placeholder="" value="NA">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Nomination Interest:</h5>
                    <input type="text" pInputText disabled=true placeholder="" value="NA">
                </div>

                <!-- <div class="col-md-12 mt-20">
                  <button type="button" class="btn btn-primary">Add</button>
             </div> -->

            </div>
            <hr>



        </div>

    </div>
</div>

<br>